import { type Book } from '@editor2/types/book';
import { type CourseState } from '@editor2/types/courseState';
import { getUpdatedValuesAndConflicts } from '../helpers/detectConflictHelper';

export class BookConflictDetector {
	detectConflicts = (state: CourseState, node) => {
		const { family_id, metadata, ...attributes } = node as Book;

		const initial = state.initialCourse.book;
		const current = state.book;
		const payload = { initial, current, incoming: node, attributes, state };

		const data = getUpdatedValuesAndConflicts(payload);
		return data;
	};

	applyDiffToInitial = ({ state, family_id, updatedInitial }) => {
		state.initialCourse.book = { family_id, ...updatedInitial };
	};

	applyDiffToCurrent = ({ state, family_id, updatedCurrent }) => {
		state.book = { family_id, ...updatedCurrent };
	};

	applyConflict = ({ state, conflicts }) => {
		state.conflicts = [...state.conflicts, ...conflicts];
	};
}
